import { compareDesc, parseISO } from 'date-fns';

export function sortByLastSynced(sources = []) {
  return sources?.sort?.((left, right) => {
    const l = parseISO(left?.lastSyncedTs || new Date().toISOString());
    const r = parseISO(right?.lastSyncedTs || new Date().toISOString());
    return compareDesc(l, r);
  });
}
